import { DESIGN_TOKENS } from '@disqotech/vinyl-design-system/design-tokens';
import { DEVICE_BREAKPOINT, LABEL_SMALL, PARAGRAPH, TITLES_NORMAL } from "Shared/styles/designConstants";
import styled from "styled-components";

type HelperProp = {
  isError: boolean;
}

type BannerContainerProps = {
  isVisible?: boolean;
}

type SubmittedContentProp = {
  shouldWrap: boolean;
}

export const ContactUsContainer = styled.div`
  width          : 100%;
  display        : flex;
  align-items    : center;
  flex-direction : column;
  padding        : 0 12px 24px;
  overflow       : auto;
`;

export const BannerContainer = styled.div<BannerContainerProps>`
  max-width: 596px;
  width    : 100%;
  margin   : 0 auto;
  display  : ${ props => props.isVisible ? 'flex' : 'none'};
`;

export const ButtonContainer = styled.div`
  margin-top: 40px;
  width     : 385px;
  max-width : 100%;

  @media ${DEVICE_BREAKPOINT.maxMobile} {
    width          : 312px;
    display        : flex;
    justify-content: center;
    align-items    : center;
  }
`;

export const HelperContainer = styled.div<HelperProp>`
  ${LABEL_SMALL.DEFAULT}
  color     : ${$props => $props.isError ? DESIGN_TOKENS.color.text.critical.value : DESIGN_TOKENS.color.text.secondary.value};
  width     : 383px;
  text-align: left;
  margin-top: 4px;

  @media ${DEVICE_BREAKPOINT.maxMobile} {
    width : 312px;
  }
`;

export const ErrorContainer  = styled.div`
  display       : flex;
  flex-direction: column;
  max-width     : 440px;
  padding-left  : 24px;
  padding-right : 24px;

  h1 {
    ${TITLES_NORMAL.FT_04}
    margin-top: 60px;
    text-align: left;
  }

  p{
    ${PARAGRAPH.DEFAULT}
    color     : ${DESIGN_TOKENS.color.text.secondary.value};
    text-align: left;
    margin-top: 24px;
  }
`;

export const SuccessfulNote = styled.p`
  width     : 383px;
  margin-top: 36px;
  color     : ${DESIGN_TOKENS.color.text.secondary.value};
  ${LABEL_SMALL.DEFAULT}

  @media ${DEVICE_BREAKPOINT.maxMobile} {
    width: 324px;
  }
`;

export const SubmittedContent = styled.div<SubmittedContentProp>`
  ${PARAGRAPH.DEFAULT}
  width      : 385px;
  height     : auto;
  word-wrap  : ${$props => $props.shouldWrap ? 'break-word' : ''};
  padding-top: 14px;

  @media ${DEVICE_BREAKPOINT.maxMobile} {
    width : 312px;
  }
`;

export const InputFieldWrapper = styled.div`
  margin-top: 28px;

  span {
    ${LABEL_SMALL.DEFAULT}
    color     : ${DESIGN_TOKENS.color.text.secondary.value};
    text-align: left;
  }
`;